/**
 * Shared operational-console UI helpers.
 * Adapted from AI Portfolio operationalConsoleUi.ts.
 */

export function detailsJsonPreview(d) {
  if (d == null) return 'пусто';
  if (typeof d === 'string') return d.length > 56 ? `${d.slice(0, 56)}…` : d;
  try {
    const s = JSON.stringify(d);
    return s.length > 56 ? `${s.slice(0, 56)}…` : s || '{}';
  } catch {
    return '?';
  }
}

export function formatDetailsJson(d) {
  if (d == null) return 'null';
  if (typeof d === 'string') return d;
  try {
    return JSON.stringify(d, null, 2);
  } catch {
    return String(d);
  }
}

/**
 * Chip class for a status value. Uses the admin-console chip contract
 * (STYLE_CONTRACT.md): the chip inherits the font size/weight of its line;
 * short status tokens keep their color (owner decision, 30.08), error stays
 * loud, emoji replaces the dot.
 */
export function statusBadgeClass(status) {
  const s = String(status || '').trim().toLowerCase();
  if (s === 'ok' || s === 'success') return 'ai-status ai-status--signal--success ai-status--emoji';
  if (s === 'error' || s === 'failed') return 'ai-status ai-status--error ai-status--emoji';
  if (s === 'pending' || s === 'started' || s === 'loading') return 'ai-status ai-status--signal--warning ai-status--emoji';
  return 'ai-status ai-status--muted ai-status--emoji';
}

export function normalizeOperationalModality(raw) {
  const k = String(raw || '').trim().toLowerCase();
  const known = ['rag', 'text', 'lms', 'mixed', 'log'];
  if (known.includes(k)) return k;
  if (k === 'mixed') return 'mixed';
  if (k.includes('rag')) return 'rag';
  if (k.includes('lms')) return 'lms';
  if (k.includes('text')) return 'text';
  return 'log';
}

/**
 * Chip class for the modality (RAG/TEXT/LMS/MIXED/LOG). Short token — keeps
 * its distinguishing color (owner decision, 30.08), but the chip inherits the
 * font size/weight of its line: no own size, no uppercase, no bold.
 */
export function operationalModalityBadgeClassList(mod) {
  const safe = normalizeOperationalModality(mod);
  const map = {
    rag: 'ai-status--signal--primary',
    text: 'ai-status--signal--success',
    lms: 'ai-status--signal--warning',
    mixed: 'ai-status--signal--info',
    log: 'ai-status--muted',
  };
  return `ai-status ${map[safe] || map.log}`;
}

export function operationalModalityFromRouteKey(routeKey) {
  const r = String(routeKey || '').trim().toLowerCase();
  if (!r) return 'log';
  if (r.includes('rag')) return 'rag';
  if (r.includes('lms')) return 'lms';
  if (r === 'text') return 'text';
  if (r.includes('mixed')) return 'mixed';
  return 'log';
}

export function pipelineStageVariant(stage, status) {
  const s = String(stage || '').toLowerCase();
  const st = String(status || '').trim().toLowerCase();
  if (st === 'error' || st === 'failed' || s.includes('error') || s.endsWith('_error')) return 'error';
  if (st === 'warning' || s.includes('warn')) return 'warning';
  if (s.includes('_started') || s.includes('loading') || s.includes('pending')) return 'loading';
  if (s.includes('_done') || s.includes('completed') || s.includes('success') || st === 'ok' || st === 'success') return 'success';
  if (s.includes('processing') || s.includes('retrieve') || s.includes('embedding') || s.includes('build')) return 'processing';
  return 'muted';
}
